<div class="bullet-container">
    <div 
        [ngClass]="{ 
            'bullet-current': i === currentStep, 
            'primary-color': currentStep >= i,
            'primary-bg-color': currentStep >= i,
            'muted-light-color': currentStep < i,
            'muted-bg-color': currentStep < i
        }" 
        class="bullet"
        *ngFor="let step of steps; index as i" 
        [attr.data-footer]="step"
    ></div>
</div>